import { SvgHome } from "icons/SvgHome"
import { SvgList } from "icons/SvgList"
import { SvgElectricity } from "icons/SvgElectricity"
import { SvgSheet } from "icons/SvgSheet"
import { SvgQuestion } from "icons/SvgQuestion"
import { SvgGalaxy } from "icons/SvgGalaxy"
import { SvgCertificate } from "icons/SvgCertificate"
import { SvgMoney } from "icons/SvgMoney"
import { SvgBasket } from "icons/SvgBasket"
import { SvgOrder } from "icons/SvgOrder"
import { SvgProfile } from "icons/SvgProfile"
import { SvgPanel } from "icons/SvgPanel"
import { SvgLogout } from "icons/SvgLogout"
import { LayoutStore } from "store/layout-store"
import { SvgClose } from "icons/SvgClose"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"

export const Nav = () => {
    const location = useLocation()
    const { displayNavMobile, setDisplayNavMobile } = LayoutStore()
    const [currentPath, setCurrentPath] = useState<string>('')

    useEffect(() => {
        setCurrentPath(location.pathname)        
    }, [location])

    return (
        <>
            <div onClick={() => { setDisplayNavMobile(false) }} className={`fixed left-0 transition-all duration-500 top-0 bottom-0 bg-[#00000098] z-[4] ${displayNavMobile ? 'right-0' : 'right-full'} `}></div>
            <div id='nav' className={`w-[256px] bg-trade-50 shadow rounded-tl-xl rounded-bl-xl py-[15px] top-0 bottom-0 bg-hoory-100   fixed z-[5] lg:right-0 -right-[400px]  transition-all duration-500 delay-300 flex flex-col overflow-y-auto ${displayNavMobile ? 'right-0' : '-right-[400px]'}`}>
                <div className="flex items-center justify-between w-full px-4 ">
                    <img src="/assets/layout/logo.png" className="w-[150px] " alt="logo" />
                    <button onClick={() => { setDisplayNavMobile(false) }} className="w-[30px] h-[30px] lg:hidden flex items-center justify-center  ">
                        <SvgClose className="w-[25px] fill-white" />
                    </button>
                </div>
                <div className="flex flex-col w-full px-3 mt-6">
                    {Data.map((item: any, index: number) =>
                        <a href={item.path}>
                            <button key={index} className={`w-full h-[40px] rounded flex items-center   mb-1 px-2  transition-all  group  ${currentPath.includes(item.suffix) ? 'bg-trade-25 text-trade-75' : 'bg-transparent hover:bg-trade-25 text-white hover:text-trade-75'}`}>
                                {item.icon}
                                <span className={`mr-2 text-sm transition-all  group-hover:mr-3 ${currentPath.includes(item.suffix) && 'mr-3'} `}>{item.title}</span>
                            </button>
                        </a>
                    )}
                </div>



            </div>
        </>
    )
}



let Data = [
    {
        'title': 'داشبورد کاربری',
        'path': '/',
        'icon': <SvgHome className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': ' چالش های ستارگان',
        'path': 'https://panel.tradestars.co/profile/packages-management',
        'icon': <SvgList className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': 'چالش های جاری',
        'path': 'https://panel.tradestars.co/profile/packages',
        'icon': <SvgElectricity className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': 'packages'
    },
    {
        'title': 'قوانین و مقررات',
        'path': 'https://panel.tradestars.co/profile/system-rules',
        'icon': <SvgSheet className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': 'تیکت پشتیبانی',
        'path': 'https://panel.tradestars.co/profile/tickets',
        'icon': <SvgQuestion className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': 'سفیران ستارگان',
        'path': 'https://panel.tradestars.co/profile/affiliate-marketing',
        'icon': <SvgGalaxy className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': 'سرتیفیکیت',
        'path': 'https://panel.tradestars.co/profile/certifications',
        'icon': <SvgCertificate className="w-[30px] stroke-gray-500 group-hover:stroke-trade-75" />,
        'suffix': null,
    },
    {
        'title': 'برداشت سود ',
        'path': 'https://panel.tradestars.co/profile/financial/account-withdraw/list',
        'icon': <SvgMoney className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': ' سبد خرید',
        'path': 'https://panel.tradestars.co/profile/financial',
        'icon': <SvgBasket className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': ' سفارشات',
        'path': 'https://panel.tradestars.co/profile/purchases',
        'icon': <SvgOrder className="w-[25px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
    {
        'title': ' پروفایل',
        'path': 'https://panel.tradestars.co/profile/account-information',
        'icon': <SvgProfile className="w-[30px] stroke-gray-500 group-hover:stroke-trade-75" />,
        'suffix': null,
    },
    {
        'title': 'احراز هویت',
        'path': '/',
        'icon': <SvgCertificate className="w-[30px] stroke-gray-500 group-hover:stroke-trade-75" />,
        'suffix': null,
    },

    {
        'title': ' خروج',
        'path': '/',
        'icon': <SvgLogout className="w-[30px] fill-gray-500 group-hover:fill-trade-75" />,
        'suffix': null,
    },
]